import { LocalizedString } from '@synergy/models';
import { ReactNode } from 'react';
import { converter } from '@synergy/utils';

import { LocalizedContext } from './localized-provider';

interface LocalizedFunctionResult {
    localization: string;
}

interface LocalizedHtmlProps {
    value?: LocalizedString;
    className?: string;
    children?: (data: LocalizedFunctionResult) => ReactNode;
}

export const LocalizedHtml = (props: LocalizedHtmlProps) => {
    if (!props.value) {
        return null;
    }

    return (
        <LocalizedContext.Consumer>
            {context => {
                const localization = context.getLocalizedString(props.value);
                return (
                    <span
                        dangerouslySetInnerHTML={{
                            __html: converter.makeHtml(localization),
                        }}
                        className={props.className}
                    />
                );
            }}
        </LocalizedContext.Consumer>
    );
};
